<script setup lang="ts">
import { useEcomStore } from '@/stores/apps/eCommerce';
import { useAuthStore } from '@/stores/auth';
const store = useEcomStore();
const authStore = useAuthStore();

const dialog = ref({
  show: computed({
    get: () => authStore.getShowLogoutModal,
    set: (value) => authStore.setShowLogoutModal(value)
  })
});

const getTotalQty = computed(() => {
  return store.getTotalQty;
});
const logoutNow = async () => {
  await authStore.logout('modal-logout');
};
</script>

<template>
  <v-dialog v-model="dialog.show" persistent max-width="500">
    <v-card class="pa-2">
      <v-card-text>
        <h3 class="text-h3">Tienes {{ getTotalQty }} productos en tu carrito!</h3>
        <p class="pt-4">Si cierras sesión se perderán <br>¿Estas seguro de salir?</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="" variant="text" @click="dialog.show = false" flat>
          No, volver
        </v-btn>
        <v-btn class="text-error" variant="text" @click="logoutNow" flat>
          Si, salir
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
